/*
Create Question and Answers
<div id="questionBox"
data-preambel = "<span class='hide-on-mobile'><?=_('Täglich wird diese Seite von 2,5 Millionen Mitgliedern aus Deutschland, Österreich und der Schweiz besucht, die nach gelegentlichen, sexuellen Begegnungen Ausschau halten. Die Wahrscheinlichkeit ist extrem hoch, dass Sie auf ein Profil von jemandem stoßen, den Sie kennen. Sie könnten hier das Profil Ihrer Bankberaterin, Ihrer Nachbarin oder sogar einer Ex-Freundin finden. Viele von diesen Mitgliedern haben auf ihrem Profil eindeutige Fotos mit sexuellem Inhalt. Falls Sie ein Mitglied erkennen, verhalten Sie sich bitte diskret und behalten Sie es für sich.')?></span>"
data-header = "<?=_('Vor der Anmeldung, beantworte bitte folgende drei Fragen:')?>"
data-titles = "<?=_('Frage 1:')?>|<?=_('Frage 2:')?>|<?=_('Frage 3:')?>"
data-questions = "<?=_('Sind sie älter als 18 Jahre?')?>|<?=_('Hatten sie schon mal eine sexuell übertragbare Krankheit?')?>|<?=_('Verwendeden sie ein Kondom bei einem One-Night Stand?')?>"
data-questions-images = "/LA/Whatsdate/img/f18videoseq.gif|/LA/Whatsdate/img/lollipop69.jpg|/LA/Whatsdate/img/lollipop69.jpg"
data-select-options = "<?=_('Wählen sie Ihre Antwort')?>|<?=_('Ja')?>|<?=_('Nein')?>"
data-button-options = "<?=_('Ja')?>|<?=_('Nein')?>"
data-button-next = "<?=_('weiter')?>"
data-search-title = "<?=_('Die Antworten werden geprüft')?>"
data-result-title = "<?=_('Ergebnisse')?>"
data-rules-title = "<?=_('Regeln')?>"
data-results = "<?=_('Zu Ihren Antworten gibt es 5256 passende weibliche Mitglieder')?>|<?=_('ihre Antworten sind korrekt.')?>|<?=_('Bitte lesen sie unsere Regeln durch.')?>"
data-rules = "<?=_('Falls sie jemanden entdecken, den sie kennen, dürfen sie niemals deren Fotos veröffentlichen...')?>|<?=_('Möchte eine Frau Geschlechtsverkehr mit Kondom, respektieren sie das bitte.')?>"
[optional:
   data-answer-image-1-1 = "LA/Whatsdate/img/f18videoseq.gif"  // Bild Frage 1, Antwort 1
   data-answer-image-1-2 = "LA/Whatsdate/img/f18videoseq.gif"  // Bild Frage 1, Antwort 2
   data-answer-image-2-1 = "LA/Whatsdate/img/f18videoseq.gif"  // Bild Frage 2, Antwort 1
   data-answer-image-2-2 = "LA/Whatsdate/img/f18videoseq.gif"  // Bild Frage 2, Antwort 2
]
></div>
*/
let drawQuestionBox, initQuestionBox;
export { drawQuestionBox, initQuestionBox };

if (typeof Zepto !== "undefined" || typeof jQuery !== "undefined") {
	var questionBoxCompleteFunc = null;
	var answeresClicked = {};
	drawQuestionBox = function () {
		var count = false;
		var $questionBox = $("#questionBox");
		var $questionTextBox = $("#questionTextBox");

		/* ----------- show questions --------------- */
		var $questionContainer = $('<div id="questionbox-container"></div>');
		var preambel = $questionBox.data("preambel");
		if (preambel) {
			$questionContainer.append($('<p class="preambel">' + preambel + "</p>"));
		}

		var header = $questionBox.data("header");
		if (header) {
			$questionContainer.append($('<h3 class="header">' + header + "</h3>"));
		}

		var questionTexts = $questionBox.data("questions-texts");
		if ($questionTextBox && questionTexts) {
			questionTexts = questionTexts.split("|");
			for (var i = 0; i < questionTexts.length; i++) {
				$questionTextBox.append(
					$(
						'<p class="question_text ' +
							(i === 0 ? "" : "hidden") +
							'" id="question_text_' +
							(i + 1) +
							'">' +
							questionTexts[i] +
							"</p>"
					)
				);
			}
		}

		var questions = $questionBox.data("questions");
		if (questions) {
			questions = questions.split("|");
			if (questions.length > 1) {
				var titles = $questionBox.data("titles");
				if (titles) {
					titles = titles.split("|");
				}
				var selOptions = $questionBox.data("select-options");
				if (selOptions) {
					selOptions = selOptions.split("|");
				}
				var btnOptions = $questionBox.data("button-options");
				if (btnOptions) {
					btnOptions = btnOptions.split("|");
				}
				var questionImages = $questionBox.data("questions-images");
				if (questionImages) {
					questionImages = questionImages.split("|");
				}
				$.each(questions, function (index, question) {
					count++;
					var $question = $('<div class="question-block hidden" id="question_' + count + '"></div>');

					$question.append(
						$('<div class="titleContainer"><h4 class="title">' + titles[index] + "</h4></div>")
					);
					$question.append($('<div class="question">' + question + "</div>"));

					if (questionImages && questionImages.length && questionImages[index]) {
						$question.append($('<img class="questionImage" src="' + questionImages[index] + '" />'));
					}

					if (selOptions.length) {
						var $answerSelect = $('<select class="answer select"></select>');
						$.each(selOptions, function (index, answer) {
							var answerText = $questionBox.data("select-option-text-" + count + "-" + (index + 1));
							$answerSelect.append(
								$('<option value="' + index + '">' + (answerText ? answerText : answer) + "</option>")
							);
						});
						$question.append($answerSelect);
					}

					if (btnOptions.length) {
						var $answerButtons = $('<div class="answers"></div>');
						$.each(btnOptions, function (index, answer) {
							var answerText = $questionBox.data("button-option-text-" + count + "-" + (index + 1));
							var answerImage = $questionBox.data("answer-image-" + count + "-" + (index + 1));
							var answerInput = $(
								'<input type="button" class="button answer" value="' +
									(answerText ? answerText : answer) +
									'" />'
							);
							if (answerImage) {
								var $answerBlock = $(
									'<div class="answer-block" id="answer' + count + "_" + (index + 1) + '"></div>'
								);
								$answerBlock.append($('<img class="answerImage" src="' + answerImage + '" />'));
								$answerBlock.append(answerInput);
								$answerButtons.append($answerBlock);
							} else {
								$answerButtons.append(answerInput);
							}
						});
						$question.append($answerButtons);
					}

					$questionContainer.append($question);
				});
			}
		}

		var nextBtn = $questionBox.data("button-next");
		if (nextBtn) {
			$questionContainer.append($('<input type="button" class="button btn-next" value="' + nextBtn + '" />'));
		}

		$questionBox.append($questionContainer);

		/*  ---------- show search -------------- */
		var $searchContainer = $('<div id="searchbox-container" class="hidden"></div>');
		var searchTitle = $questionBox.data("search-title");
		$searchContainer.append(
			$('<div class="searchbox-loader-container"><div class="searchbox-loader hidden"></div></div>')
		);
		$searchContainer.append($('<h3 class="header search-title hidden">' + searchTitle + "</h3>"));
		$questionBox.append($searchContainer);

		/*  ---------- show answers -------------- */
		var results = $questionBox.data("results");
		var rules = $questionBox.data("rules");

		if (results || rules) {
			var $answerContainer = $('<div id="answerbox-container" class="hidden"></div>');

			if (results) {
				results = results.split("|");
				if (results.length > 1) {
					var resultTitle = $questionBox.data("result-title");
					if (resultTitle) {
						$answerContainer.append($('<h3 class="header result-title hidden">' + resultTitle + "</h3>"));
					}
					var $resultBlock = $('<ol class="results"></ol>');
					$.each(results, function (index, result) {
						$resultBlock.append('<li id="result_' + index + '" class="result hidden">' + result + "</li>");
					});
				}
				$answerContainer.append($resultBlock);
			}

			if (rules) {
				rules = rules.split("|");
				if (rules.length > 0) {
					var ruleTitle = $questionBox.data("rules-title");
					if (ruleTitle) {
						$answerContainer.append($('<h3 class="header rules-title hidden">' + ruleTitle + "</h3>"));
					}
					var $rulesBlock = $('<ol class="rules"></ol>');
					$.each(rules, function (index, rule) {
						$rulesBlock.append('<li id="result_' + index + '" class="rule hidden">' + rule + "</li>");
					});
				}
				$answerContainer.append($rulesBlock);
			}

			$questionBox.append($answerContainer);
		}

		$questionBox.removeAttr(
			"data-preambel data-header data-titles data-questions data-questions-texts data-select-options data-button-options data-button-next data-search-title data-result-title data-rules-title data-results data-rules"
		);
		return count;
	};

	var sendAnswer = function (answer) {
		if (!answer) {
			// next button clicked -> find current question
			$.each($("#questionbox-container").find(".question-block"), function (index, question) {
				if ($(question).css("display") != "none") {
					answer = $(question).find("input, select").first();
					return;
				}
			});
		}

		var $question = $(answer).closest(".question-block");
		var id = $question ? $question.attr("id") : 0;
		var index = id ? id.substr(9) : 0; //question_2  => 2
		var $next = $("#question_" + ++index);
		var $next_text = $("#question_text_" + index);
		var $answer = $(answer).closest(".answer-block");
		var answerId = $answer ? $answer.attr("id") : 0;
		if (typeof answerId !== "undefined") {
			answeresClicked[id.slice(-1)] = answerId.slice(-1);
		}

		$question.fadeOut("fast", function () {
			if ($next.length) {
				$next.fadeIn("fast");
			}
		});

		$("#question_text_" + (index - 1)).fadeOut("fast", function () {
			if ($next_text.length) {
				$next_text.fadeIn("fast");
			}
		});

		if ($next.length === 0) {
			// no more question
			$("#questionbox-container").fadeOut("slow", function () {
				startSearch();
			});
		}
	};

	var startSearch = function () {
		var $answerBox = $("#answerbox-container");
		if ($answerBox && $answerBox.length) {
			var $searchBox = $("#searchbox-container");
			$searchBox.removeClass("hidden");

			$searchBox.find(".search-title").fadeIn("slow", function () {
				showResult();
				$searchBox.find(".searchbox-loader").removeClass("hidden");
				$searchBox.find(".search-title").fadeOut("slow");
				$searchBox.find(".searchbox-loader").animate(
					{
						width: "100%",
					},
					2000,
					"linear",
					function () {
						$searchBox.find(".searchbox-loader").fadeOut("slow", function () {
							$searchBox.addClass("hidden");
						});
					}
				);
			});
		} else {
			if (typeof questionBoxCompleteFunc == "function") {
				questionBoxCompleteFunc(answeresClicked);
			}
		}
	};

	var showResult = function () {
		var $box = $("#answerbox-container");

		var results = $box.find(".result");
		if (results.length) {
			$box.removeClass("hidden");
			$.each(results, function (index, result) {
				if (index === 0) {
					$("#answerbox-container .result-title").fadeIn("fast");
				}
				window.setTimeout(function () {
					$(result).fadeIn("fast");
				}, ++index * 500);
			});
			window.setTimeout(showRules, (results.length + 1) * 500);
		}
	};

	var showRules = function () {
		var $box = $("#answerbox-container");

		var rules = $box.find(".rule");
		if (rules.length) {
			$.each(rules, function (index, rule) {
				if (index === 0) {
					$("#answerbox-container .rules-title").fadeIn("fast");
				}
				window.setTimeout(function () {
					$(rule).fadeIn("fast");
				}, ++index * 500);
			});
		}

		if (typeof questionBoxCompleteFunc == "function") {
			window.setTimeout(questionBoxCompleteFunc(answeresClicked), (rules.length + 1) * 500);
		}
	};

	initQuestionBox = function (completeFunc) {
		questionBoxCompleteFunc = typeof completeFunc == "function" ? completeFunc : function () {};

		$.each($("#questionbox-container").find(".question-block"), function (index, question) {
			$.each($(question).find("select.answer"), function (key, sel) {
				$(sel).on("change", function () {
					sendAnswer(this);
				});
			});
			$.each($(question).find("input.answer"), function (key, btn) {
				$(btn).on("click", function () {
					sendAnswer(this);
				});
			});
			$.each($(question).find(".answerImage"), function (index, answer) {
				$(answer).on("click", function () {
					sendAnswer($(this).parent().find("input"));
				});
			});
			if (index === 0) {
				//show first
				$(question).removeClass("hidden");
			}
		});

		$("#questionbox-container")
			.find(".btn-next")
			.on("click", function () {
				sendAnswer(null);
			});
	};
}
